import { Table } from '@dreryk/react-components';

import { TABLE_PAGE_SIZE } from '../shared/constants';

import {
   useChronicDiseaseInformationDataConfiguration,
   useChronicDiseaseInformationTableColumns,
} from './ChronicDiseaseInformationTable.hooks';

type ChronicDiseaseInformationTableProps = {
   readonly patientId: number;
   readonly highlightedEntryId?: number;
};

export const ChronicDiseaseInformationTable = (props: ChronicDiseaseInformationTableProps): JSX.Element => {
   const dataConfiguration = useChronicDiseaseInformationDataConfiguration(props.patientId);
   const columns = useChronicDiseaseInformationTableColumns(dataConfiguration.refetch);

   return (
      <Table
         testId={'chronicDiseaseInformation'}
         keyExtractor={'id'}
         columns={columns}
         dataConfiguration={dataConfiguration}
         pageSize={TABLE_PAGE_SIZE}
         highlightedRowKey={props.highlightedEntryId}
      />
   );
};
